import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import type {FC} from 'react'
import {AnimatedListContainerVariation} from './ContainerVariation'
import {AnimatedListDefault} from './DefaultVariation'
import {MapVariation} from './MapVariation'

/**
 * Props for `AnimatedList`.
 */
export type AnimatedListProps = SliceComponentProps<Content.AnimatedListSlice>

/**
 * Component for "AnimatedList" Slices.
 */
const AnimatedList: FC<AnimatedListProps> = ({slice}) => {
  switch (slice.variation) {
    case 'default':
      return <AnimatedListDefault slice={slice} />
    case 'withContainer':
      return <AnimatedListContainerVariation slice={slice} />
    case 'map':
      return <MapVariation slice={slice} pageUid={slice.id} componentIndex={0} />
    default:
      return <></>
  }
}

export default AnimatedList
